module.exports = __webpack_public_path__ + "static/media/megaphone-dg.75cd829f.svg";